var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "FilterToggle",
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filters.query,
                expression: "filters.query",
              },
            ],
            attrs: { type: "hidden" },
            domProps: { value: _vm.filters.query },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.filters, "query", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("FormControlSector", {
            attrs: {
              name: "sectors",
              multiple: true,
              "include-ancestors": false,
            },
            model: {
              value: _vm.filters.sectors,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "sectors", $$v)
              },
              expression: "filters.sectors",
            },
          }),
          _vm._v(" "),
          _c("FormControlDealType", {
            attrs: { name: "deal_type" },
            model: {
              value: _vm.filters.deal_type,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "deal_type", $$v)
              },
              expression: "filters.deal_type",
            },
          }),
          _vm._v(" "),
          _c("FormControlMember", {
            attrs: {
              name: "member",
              placeholder: "Select...",
              label: "Member company",
            },
            model: {
              value: _vm.filters.member,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "member", $$v)
              },
              expression: "filters.member",
            },
          }),
          _vm._v(" "),
          _c("FormControlDatepicker", {
            attrs: { name: "fromDate", label: "From date" },
            model: {
              value: _vm.filters.fromDate,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "fromDate", $$v)
              },
              expression: "filters.fromDate",
            },
          }),
          _vm._v(" "),
          _c("FormControlDatepicker", {
            attrs: { name: "toDate", label: "To date" },
            model: {
              value: _vm.filters.toDate,
              callback: function ($$v) {
                _vm.$set(_vm.filters, "toDate", $$v)
              },
              expression: "filters.toDate",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__group download" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-download",
                attrs: {
                  href: _vm.downloadURL,
                  disabled: _vm.$wait.is("loading_search_opportunities"),
                },
              },
              [_vm._v("Download All")]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("OpportunityTableHeader", {
        on: { changeSort: _vm.handleSortChange },
      }),
      _vm._v(" "),
      _vm.$wait.is("loading_search_opportunities")
        ? _c(
            "div",
            { staticClass: "loading" },
            [_c("Spinner", { attrs: { height: 40, width: 40 } })],
            1
          )
        : _vm.items && _vm.items.length > 0
        ? _c(
            "div",
            [
              _c(
                "ul",
                { staticClass: "search-results" },
                _vm._l(_vm.items, function (item) {
                  return _c(
                    "li",
                    [
                      _c("OpportunitySearchResult", {
                        attrs: { resource: item },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("Pagination", {
                ref: "pagination",
                on: { "vuetable-pagination:change-page": _vm.onChangePage },
              }),
            ],
            1
          )
        : _c("div", { staticClass: "no-results" }, [
            _vm._v("\n        No results\n    "),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }